import { statusOf } from "@common/api";
import { createQueryClient } from "@jkast90/kast-common/query-client";

export const queryClient = createQueryClient({ statusOf });
